import type { User } from 'oidc-client-ts'

type SigninSilentFn = () => Promise<User | null>

let _fn: SigninSilentFn = () => Promise.resolve(null)

export const signinSilent = (): Promise<User | null> => _fn()

export const registerSigninSilent = (fn: SigninSilentFn): void => {
  _fn = fn
}

export const unregisterSigninSilent = (): void => {
  _fn = () => Promise.resolve(null)
}
